const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

const LAYOUT_TYPE = {
  STANDARD: "standard",
  EMPTY_MIDDLE: "empty_middle",
};

const TB_LIST = "list";
const TB_LIST_MOVIE = "list_movie";
const TB_MOVIE = "movie";
const TB_REVIEW_REFERENCE = "review_reference";
const TB_POST = "post";
const TB_POST_SCENE = "post_scene";
const TB_REVIEW = "review";
const TB_REVIEW_SCENE = "review_scene";

const POST_ID_BUFFER_LENGTH_REF = {
  1: 29,
  2: 41,
  3: 43,
  5: 18,
}

export {
  SUPABASE_KEY,
  SUPABASE_URL,
  TB_LIST,
  TB_LIST_MOVIE,
  TB_MOVIE,
  TB_REVIEW,
  TB_REVIEW_SCENE,
  TB_REVIEW_REFERENCE,
  TB_POST,
  TB_POST_SCENE,
  POST_ID_BUFFER_LENGTH_REF,
  LAYOUT_TYPE,
};
